<template>
  <div v-click-outside="closeOptionsModal" class="password-options-modal">
    <h1 class="options-title">{{ $t("campaignManager.options") }}</h1>
    <div class="options">
      <button class="option-button" @click="openChangePassword">
        <PasswordIcon class="edit-icon" />{{
          user.user.hasPassword
            ? $t("account.updatePassword")
            : $t("account.setPassword")
        }}
      </button>
      <button
        v-if="user.user.hasPassword"
        class="option-button"
        @click="logOut"
      >
        <LogoutIcon class="edit-icon log-out-icon" />{{ $t("account.logOut") }}
      </button>
      <button class="option-button" @click="cancelSubscription">
        <TrashIcon class="edit-icon" />
        {{ $t("account.deleteAccount") }}
      </button>
    </div>
  </div>
</template>

<script>
import PasswordIcon from "@/assets/svg/password-icon.svg?inline";
import LogoutIcon from "@/assets/svg/log-out-icon.svg?inline";
import TrashIcon from "@/assets/svg/trash-icon-small.svg?inline";

import { mapState } from "vuex";

export default {
  components: {
    PasswordIcon,
    LogoutIcon,
    TrashIcon,
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    closeOptionsModal() {
      this.$emit("close-options-modal");
    },
    openChangePassword() {
      this.$emit("open-change-password");
    },
    logOut() {
      this.$emit("log-out");
    },
    cancelSubscription() {
      this.$emit("cancel-subscription");
    },
  },
};
</script>
<style lang="scss" scoped>
.password-options-modal {
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.25);
  padding: 16px;
  z-index: 99;
  background: white;
  position: absolute;
  bottom: 110px;
  right: 25px;
  border-radius: 4px;
  border: 1px solid rgb(196, 196, 196);
}
.options-title {
  @include base-font;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  color: $light-grey;
  margin-bottom: 16px;
}
.options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}
.option-button {
  @include base-font;
  background: transparent;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: $dark-grey;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  position: relative;
  text-align: left;
  &:hover {
    width: 100%;
    background: $dark-purple;
    color: white;
    border-radius: 4px;
    text-align: left;
    .edit-icon path {
      fill: white;
    }
  }
}

.disabled-button {
  @include base-font;
  background: transparent;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: $light-grey;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  position: relative;
  text-align: left;
  cursor: not-allowed;
  .icon {
    path {
      fill: $light-grey;
    }
  }
}

.log-out-icon {
  path {
    fill: #585858;
  }
}
</style>
